
const State = {
    member: {},
    projects: [],



    error: {
        show: false,
        data: {}
    },



    // Current version in Editor
    editor: {
        version: null,
        validator: {
            event: null,
            hasError: false,
            hasWarning: false,
            errors: [],
            warnings: []
        }
    },
    isSavingStudy: false,
    isStudyEditorCollapsed: true,

    dataView: {
        isLoaded: false,
        currentId: null,
        forecast: {},
        chartDefaults: {
            legend: {
                align: "left",
                verticalAlign: "top",
                borderWidth: 0
            },
            title: {
                text: null
            },
            xAxis: {
                title: {
                    text: null
                }
            },
            yAxis: {
                title: {
                    text: null,
                    margin: 40
                },
                labels: {
                    align: "left",
                    x: -30,
                    y: 3
                }
            },
            tooltip: {
                shared: true,
                crosshairs: true,
            },
            plotOptions: {
                line: {
                    lineWidth: 4,
                    marker: {
                        enabled: false
                    }
                },
                column: {
                    grouping: false
                },
                series: {
                    turboThreshold: 0
                }
            },
            credits: {
                enabled: false
            }
        },
        azureMaps: {
            authOptions: {
                authType: "subscriptionKey",
                subscriptionKey: "oinVeFC_LFSQh8e8VHWDFpB18h4f2wGMeKJG9P1bLao"
            }
        }
    }
};

export default State
